export default __webpack_public_path__ + "static/media/edit-image.5b2e8203.svg";